module.exports = __webpack_public_path__ + "static/media/3_col_2.0d17cda4.jpg";